import { Injectable } from "@angular/core";
import { ContactDetailsSession } from "../../api/models/contactDetailsSession";
import { PlacardEditionRequest } from "../../api/models/placardEdit";
import { Contact } from "../../interface/upplm.placardInformation";

@Injectable()

export class ContactDetailsHelperService {

    constructor() { }

    prepareContactDetailsForEdit(contactDetails: Contact[]): ContactDetailsSession {

        let requestor = contactDetails.find((contact) => contact.contactType == '01');
        let primaryContact = contactDetails.find((contact) => contact.contactType == '02');

        let contactDetailsSession = {
            name: requestor.name,
            email: requestor.email,
            phone: requestor.phone,
            ext: requestor.phoneExt,
            makePrimaryContact: this.isPrimaryContact(contactDetails),
            primaryName: primaryContact.name,
            primaryEmail: primaryContact.email,
            primaryPhone: primaryContact.phone,
            primaryExt: primaryContact.phoneExt
        } as ContactDetailsSession;

        return contactDetailsSession;
    }

    private isPrimaryContact(contactDetails: Contact[]): boolean {

        return ((contactDetails[0].email === contactDetails[1].email)
            && (contactDetails[0].name === contactDetails[1].name)
            && (contactDetails[0].phone === contactDetails[1].phone)
            && (contactDetails[0].phoneExt === contactDetails[1].phoneExt));
    }

    prepareSaveEditionRequest(editedContacts: ContactDetailsSession): PlacardEditionRequest {
        let placardEditionRequest = new PlacardEditionRequest();
        let contactDetails: Contact[] = [];

        contactDetails.push({
            contactType: '01',
            name: editedContacts.name,
            email: editedContacts.email,
            phone: editedContacts.phone,
            phoneExt: editedContacts.ext,
            locale: 'en_US'
        });

        contactDetails.push({
            contactType: '02',
            name: editedContacts.primaryName,
            email: editedContacts.primaryEmail,
            phone: editedContacts.primaryPhone,
            phoneExt: editedContacts.primaryExt,
            locale: 'en_US'
        });

        placardEditionRequest.contactDetails = contactDetails;
        return placardEditionRequest;
    }

}